import { render, staticRenderFns } from "./NumberEdit.vue?vue&type=template&id=53136cfc&"
import script from "./NumberEdit.vue?vue&type=script&lang=js&"
export * from "./NumberEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports